import { render, staticRenderFns } from "./appActivate.vue?vue&type=template&id=1320988f&scoped=true&"
import script from "./appActivate.vue?vue&type=script&lang=js&"
export * from "./appActivate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320988f",
  null
  
)

export default component.exports